export default __webpack_public_path__ + "static/media/RhymesWeather_13.a1194e88.png";